import React from 'react';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import Details from './emailDetails';
import EmailLink from './email-link';
import './email-quiz-mdlz-newsletter.scss';
import PresentationHeading from './presentation-heading';
import DefaultTrans from '../default-i18next-trans';

const { REACT_APP_STATIC_PREFIX = '/static' } = import.meta.env;

export const EmailQuizMdlzNewsletter = observer(
    ({ ui, onAction, userEmail, userName }) => {
        const { t } = useTranslation('assessment');
        const [isShowingDetails, setIsShowingDetails] = React.useState(false);
        //const [isShowingPath, setIsShowingPath] = React.useState(false);
        const [hoverStartTime, setHoverStartTime] = React.useState(null);
        const [isShowingLinkAlert, setIsShowingLinkAlert] =
            React.useState(false);

        const link = ui.link;
        const address = ui.address;

        const handleShowDetails = () => {
            if (!isShowingDetails) {
                address.clickActionId &&
                    onAction &&
                    onAction(address.clickActionId);
            }
            setIsShowingDetails(!isShowingDetails);
        };

        const handleLinkMouseEnter = () => {
            //setIsShowingPath(true);
            setHoverStartTime(new Date());
        };

        const handleLinkMouseLeave = () => {
            //setIsShowingPath(false);
            let attachmentHoverEnd = new Date();
            //Only fire the action if user hovers over attachment for more than 3 seconds
            if (attachmentHoverEnd - hoverStartTime > 2000) {
                onAction && onAction(link.hoverActionId);
            }
        };

        const handleLinkClick = () => {
            setIsShowingLinkAlert(true);
        };

        return (
            <div className="assessment-presentation">
                <div className="question">
                    <PresentationHeading ui={ui} />

                    <div className="email-gmail mdlz-newsletter">
                        <div className="email-header">
                            <div
                                className="profile-img"
                                style={{
                                    backgroundColor:
                                        ui.email.avatar_background_color ||
                                        '#2E56E4',
                                }}
                            >
                                {t(ui.email.from_initials)}
                            </div>
                            <div className="email-top-line">
                                <div className="details-header">
                                    <span className="from">
                                        {t(ui.email.from_name)}
                                    </span>
                                    <span className="mobileOnly mobile-email-time">
                                        {t('gmail_short_time')}
                                    </span>
                                    <span className="desktopOnly email-time">
                                        {t('gmail_long_time')}
                                    </span>
                                    <div className="email-icons">
                                        <img
                                            className="desktopOnly"
                                            src={`${REACT_APP_STATIC_PREFIX}/img/assessment/icon/star_border_24px.svg`}
                                            alt={t('Star')}
                                        />
                                        <img
                                            src={`${REACT_APP_STATIC_PREFIX}/img/assessment/icon/reply_24px.svg`}
                                            alt={t('Reply')}
                                        />
                                        <img
                                            src={`${REACT_APP_STATIC_PREFIX}/img/assessment/icon/more_vert_24px.svg`}
                                            alt={t('More')}
                                        />
                                    </div>
                                </div>
                                <Details
                                    ui={ui}
                                    fromName={t(ui.email.from_name)}
                                    fromEmail={t(ui.email.from_address)}
                                    userEmail={userEmail}
                                    userName={userName}
                                    subject={t(ui.email.subject)}
                                    onShowDetails={handleShowDetails}
                                    t={t}
                                />
                            </div>
                        </div>

                        <div className="email-text">
                            <div className="mdlz-email-header">
                                <img
                                    src={`${REACT_APP_STATIC_PREFIX}/img/assessment/email-header-mdlz.png`}
                                    alt={t('Need to do')}
                                />
                            </div>
                            <p>
                                <Trans
                                    defaults={t(ui.email.text)}
                                    components={{
                                        strong: <strong />,
                                        u: (
                                            <EmailLink
                                                onClick={handleLinkClick}
                                                onMouseLeave={
                                                    handleLinkMouseLeave
                                                }
                                                onMouseEnter={
                                                    handleLinkMouseEnter
                                                }
                                                link={link}
                                            />
                                        ),
                                    }}
                                >
                                    {t(ui.email.text)}
                                </Trans>
                            </p>
                            <Row>
                                <Col md="4" xs="12">
                                    <div className="img">
                                        <img
                                            src={`${REACT_APP_STATIC_PREFIX}/img/assessment/email-windows10-logo.png`}
                                            alt={t('Windows 10')}
                                        />
                                    </div>
                                </Col>
                                <Col md="8" xs="12">
                                    <div className="blue">
                                        <strong>
                                            {t('Important pre-upgrade tasks')}
                                        </strong>
                                        <ul>
                                            <li>
                                                <DefaultTrans
                                                    translatedString={t(
                                                        'Start now by making time for the upgrade'
                                                    )}
                                                />
                                            </li>
                                            <li>
                                                <DefaultTrans
                                                    translatedString={t(
                                                        'Move your files to OneDrive for Business'
                                                    )}
                                                />
                                            </li>
                                            <li>
                                                <DefaultTrans
                                                    translatedString={t(
                                                        'Restart your PC before the upgrade'
                                                    )}
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="mdlz-email-footer">
                            {t(
                                'For help with your Windows 10 upgrade, contact User First IT Support (Service Desk) using your preferred method — Skype for Business chat, phone, or email.'
                            )}
                        </div>

                        <div
                            className="email-attention"
                            style={{ opacity: isShowingLinkAlert ? '1' : '0' }}
                        >
                            {t('Links don’t work. This is only a simulation')}.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);
